import { create, type StoreApi, type UseBoundStore } from 'zustand';

interface BannerStoreConfig {
	isBannerDismissed: () => boolean;
	setBannerDismissed: (dismissed: boolean) => void;
	getDismissCount: () => number;
	incrementDismissCount: () => number;
	resetDismissCount: () => void;
}

interface BannerStore {
	visible: boolean;

	setVisible: (visible: boolean) => void;
}

const DISMISS_THRESHOLD = 3;

export const createMobileBannerStore = (
	config: BannerStoreConfig
): UseBoundStore<StoreApi<BannerStore>> =>
	create<BannerStore>((set) => ({
		visible: !config.isBannerDismissed(),

		setVisible: (visible) => {
			if (visible && config.isBannerDismissed()) {
				return;
			}

			if (!visible && !config.isBannerDismissed()) {
				const newCount = config.incrementDismissCount();

				if (newCount >= DISMISS_THRESHOLD) {
					config.setBannerDismissed(true);
					config.resetDismissCount();
					set({ visible: false });
					return;
				}
			}
			set({ visible });
		}
	}));
